const ExpectedReturnsIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2217_10929)" />
      <path
        d="M44.4217 52C53.1465 49.047 58.0459 39.8524 55.764 30.9933C53.5492 22.4698 45.764 17.7047 38.4486 17.9732C38.4486 18.7785 38.4486 19.5839 38.4486 20.4564C35.6298 19.047 32.811 17.6376 29.9922 16.2282C32.811 14.8188 35.6298 13.4094 38.4486 12C38.4486 12.8725 38.4486 13.6779 38.4486 14.5503C44.9586 14.6174 50.2606 17.1007 54.2204 22.2685C57.0392 25.9597 58.3143 30.1879 58.0459 34.8188C57.4419 44.2148 50.5291 50.3893 44.4217 52Z"
        fill="white"
      />
      <path
        d="M28.188 46.9809C28.188 46.8411 28.188 46.7712 28.188 46.6314C28.188 45.5828 28.188 44.5341 28.188 43.4855C28.188 43.0661 28.3278 42.7165 28.6773 42.4369C30.1454 41.1785 31.5436 39.9202 33.0117 38.6618C33.0816 38.5919 33.1515 38.522 33.2913 38.4521C32.9418 38.1725 32.5922 37.8229 32.2427 37.5433C31.0542 36.4947 29.8658 35.446 28.6773 34.4673C28.3278 34.1877 28.188 33.8381 28.188 33.4187C28.188 32.3701 28.188 31.3214 28.188 30.2728C28.188 30.2029 28.188 30.0631 28.188 29.9932C32.5922 29.9932 37.0664 29.9932 41.4706 29.9932C41.4706 30.0631 41.4706 30.133 41.4706 30.2728C41.4706 31.3214 41.4706 32.3701 41.4706 33.4187C41.4706 33.8381 41.3308 34.1877 40.9813 34.4673C39.5132 35.7257 37.9752 37.0539 36.5071 38.3123C36.4372 38.3822 36.4372 38.3822 36.3673 38.4521C36.6469 38.7317 36.9266 38.9415 37.2062 39.2211C38.4645 40.2697 39.7229 41.3883 40.9813 42.4369C41.3308 42.7165 41.4706 43.0661 41.4706 43.5554C41.4706 44.6041 41.4706 45.6527 41.4706 46.7013C41.4706 46.7712 41.4706 46.911 41.4706 46.9809C36.9965 46.9809 32.5922 46.9809 28.188 46.9809Z"
        fill="white"
      />
      <path
        d="M27 28.9447C27 28.2457 27 27.6165 27 26.9873C32.1732 26.9873 37.4164 26.9873 42.5896 26.9873C42.5896 27.6165 42.5896 28.3156 42.5896 28.9447C37.4164 28.9447 32.1732 28.9447 27 28.9447Z"
        fill="white"
      />
      <path
        d="M27 49.9872C27 49.2881 27 48.659 27 48.0298C32.1732 48.0298 37.4164 48.0298 42.5896 48.0298C42.5896 48.659 42.5896 49.358 42.5896 49.9872C37.4164 49.9872 32.1732 49.9872 27 49.9872Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2217_10929"
          x1="35"
          y1="0"
          x2="35"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F36636" />
          <stop offset="1" stop-color="#D84800" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ExpectedReturnsIconSubcategory
